import React, { useState } from "react";

export default function ImageWithFallback({ src, alt, style, className }) {
  const [failed, setFailed] = useState(false);
  const fallbackText = alt || "Image unavailable";

  if (failed) {
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#334155",
          background: "linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)",
          border: "1px dashed #cbd5e1",
          padding: "12px",
          fontSize: "0.92rem",
          fontWeight: 500,
          lineHeight: 1.4,
          minHeight: style?.height ? undefined : 120,
          gap: 8,
        }}
        role="img"
        aria-label={fallbackText}
      >
        <span aria-hidden="true" style={{ fontSize: "1.1rem" }}>
          🖼️
        </span>
        <span>{fallbackText}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
